<template>
  <lazy-component class="chart-lazy-wrapper" ref="lazy">
    <chart :nid="nid" :chartIndex="chartIndex" v-if="chartIndex"></chart>
  </lazy-component>
</template>

<script>
import Chart from 'components/chart/Chart.vue'
import get from 'lodash/get'

export default {
  name: 'body-chart',
  props: ['item', 'nid'],
  components: {
    Chart,
  },
  computed: {
    chartIndex() {
      return get(this, 'item.content.attr.data-chart-id', false)
    },
  },
}
</script>



// WEBPACK FOOTER //
// Chart.vue?3af134c6